export default "__VITE_ASSET__JepLmo$m__"